/**
 * English - `aiCredits`: the plan's two monthly AI allowances, the shared wallet
 * of bought credits, and buying more.
 *
 * Keys: `panel.*` for the AI credits section of the billing page, `buy.*` for
 * the buy button and the purchase dialog, `banner.*` for the running-low banner
 * on the screens that spend AI, `offer.*` for the "buy credits" line under a
 * plan-limit error, and `operations.*` for the credit history's names for
 * drafts paid with bought credits (image operations are `aiImages.operations`).
 */
const aiCredits: Record<string, string> = {
  'panel.title': 'AI credits',
  'panel.description':
    'Your plan includes a monthly allowance for AI images and for AI drafts and translations. Bought credits top up either once it runs out.',
  'panel.images': 'AI images',
  'panel.images_unit': 'image credits',
  'panel.text': 'AI drafts & translations',
  'panel.text_unit': 'drafts',
  'panel.text_cost_one': 'After the allowance, each draft uses {count} bought credit.',
  'panel.text_cost_other': 'After the allowance, each draft uses {count} bought credits.',
  'panel.used_of': '{remaining} {unit} left this month',
  'panel.used_unlimited': '{used} {unit} used this month',
  'panel.bought': 'Bought credits',
  'panel.resets': 'Allowance resets',
  'panel.wallet_note':
    'Bought credits are used only after your monthly allowance, never expire, and do not change your plan.',
  'panel.wallet_note_no_packs':
    'Bought and granted credits are used only after your monthly allowance and never expire.',
  'panel.pack_bought': '{credits} credits bought',
  'panel.credits_granted': '{credits} credits added by NeonCarts',

  'buy.button': 'Buy AI credits',
  'buy.view_billing': 'See AI credits',
  'buy.title': 'Buy AI credits',
  'buy.intro': 'Choose a pack. It is a one-off payment - your plan and its price stay the same.',
  'buy.packs_label': 'Credit packs',
  'buy.pack_credits': '{credits} credits',
  'buy.fact_plan': 'Works for AI images, product descriptions, themes and translations.',
  'buy.fact_order': 'Used only once your monthly allowance runs out.',
  'buy.fact_expiry': 'Bought credits never expire.',
  'buy.choose': 'Choose a pack',
  'buy.pay': 'Pay {price}',
  'buy.cancel': 'Cancel',
  'buy.done': 'Done',
  'buy.none_on_sale': 'No credit packs are on sale right now.',
  'buy.order_name': '{credits} AI credits',
  'buy.confirming': 'Payment received. Adding your credits…',
  'buy.paid': '{credits} credits have been added to your account.',
  'buy.slow':
    'Your payment is still being confirmed. The credits will appear here as soon as it is - you can close this window.',
  'buy.dismissed': 'The payment was not completed. Nothing has been charged.',
  'buy.failed': 'The payment did not go through. Nothing has been added.',
  'buy.start_failed': 'We could not start the payment just now. Please try again.',
  'buy.open_failed': 'We could not open the payment window. Please try again.',

  'banner.title_low': 'You are running low on AI credits',
  'banner.title_empty': 'You have used this month’s AI allowance',
  'banner.body': 'You have {left} left. Your allowance resets on {date}.',
  'banner.images_left_one': '{count} image credit',
  'banner.images_left_other': '{count} image credits',
  'banner.drafts_left_one': '{count} AI draft',
  'banner.drafts_left_other': '{count} AI drafts',

  'offer.body':
    'Keep going now with a pack of AI credits - a one-off payment that does not change your plan.',

  'operations.PRODUCT_COPY': 'Product description draft',
  'operations.THEME_GENERATION': 'Theme draft',
  'operations.TRANSLATION': 'AI translation',
};

export default aiCredits;
